export default __webpack_public_path__ + "static/media/instant-rebate.4a1082af.svg";